module.exports = __webpack_public_path__ + "static/media/logo.65f3bd0c.png";